module.exports = __webpack_public_path__ + "static/media/back.64e97270.svg";